document.addEventListener("DOMContentLoaded", function () {
  const totalSlides = document.querySelectorAll(".swiper-slide").length;
  let currentSlide = 1;

  const prevButton = document.querySelector(".custom-button-swiper-prev");
  const nextButton = document.querySelector(".custom-button-swiper-next");
  const paginationElement = document.getElementById("podcast-pagination");

  const podcastSwiper = new Swiper(".podcast-swiper", {
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: {
      nextEl: ".custom-button-swiper-next",
      prevEl: ".custom-button-swiper-prev",
    },
    breakpoints: {
      640: { slidesPerView: 1 },
      768: { slidesPerView: 2, spaceBetween: 30 },
      1024: { slidesPerView: 2.5, spaceBetween: 40 },
    },
  });


  function updatePagination() {
   
    if (paginationElement) {
      paginationElement.dataset.current = currentSlide;
      paginationElement.textContent = `${currentSlide}/${totalSlides}`;
    }

    if (prevButton) {
      prevButton.disabled = currentSlide === 1;
    }
    if (nextButton) {
      nextButton.disabled = currentSlide === totalSlides;
    }

    podcastSwiper.update();
  }

  if (prevButton) {
    prevButton.addEventListener("click", function () {
      if (currentSlide > 1) {
        currentSlide--;
        updatePagination();
      }
    });
  }

  if (nextButton) {
    nextButton.addEventListener("click", function () {
      if (currentSlide < totalSlides) {
        currentSlide++;
        updatePagination();
      }
    });
  }

  updatePagination();
});
